import React, {useState, useEffect, useRef} from 'react';
import { useNavigate, Link} from 'react-router-dom';
import { useForm } from "react-hook-form";
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled, alpha, useTheme } from '@mui/material/styles';
import {AppBar,Box,Toolbar,IconButton, BottomNavigation, BottomNavigationAction,InputBase,Badge,MenuItem,Menu} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));
  
  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '50ch',
      },
    },
  }));

const TopMenu = () => {
  const { register, handleSubmit, setValue } = useForm();
  const [inputValue, setInputValue] = useState('');
  const [bottomMenuValue, setBottomMenuValue] = useState(0);
  const history = useNavigate();
  const inputRef = useRef();


  const theme = useTheme();
  const matchesResolution = useMediaQuery(theme.breakpoints.up('sm'));

  const onChangeHandler = (data) => {
    const patternTest = new RegExp('^[a-zA-Z\u00C0-\u00FF0-9 -]*$');
    const isValidQuery = patternTest.test(String(data))
    if(isValidQuery == true){
      setInputValue(data)
    }else{
    }
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    //if(data.searchContent.length > 0){history(`/Search/${data.searchContent}/1`)}
    if(inputValue.length > 0){history(`/Search/${inputValue}/1`)}
  };
  const onError = (errors, e) => console.log(errors, e);
  
    const menuId = 'primary-search-account-menu';
 
    return(
        <>
        
             <Box sx={{ flexGrow: 1 }}>
             <AppBar position="fixed" style={{backgroundColor:"rgb(6 6 6 / 85%)", zIndex:"9999"}}>
               <Toolbar>
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                 <Link to="/" style={{textDecoration:"none", color:"#fff"}}>
                 <IconButton
                     size="large"
                     edge="end"
                     aria-label="back to homepage"
                     aria-haspopup="true"
                     color="inherit"
                   >
                     <HomeRoundedIcon />
                   </IconButton>
                 </Link>
                 </Box>
                 <form onSubmit={handleSubmit(onSubmit, onError)} autoComplete='off'>
                 <Search>
                   <SearchIconWrapper >
                     <SearchIcon />
                   </SearchIconWrapper>
                   <StyledInputBase
                     name="searchContent"
                     placeholder="Buscar…"
                     inputProps={{ 'aria-label': 'search','ref':inputRef }}
                     value={inputValue}
                     {...register("searchContent",
                       { onChange: (e) => {onChangeHandler(e.target.value)}},
                       { required:true,},
                     
                     )}
                     
                   />
                 </Search>
                 </form>
                 <Box sx={{ flexGrow: 1 }} />
                 <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                 
                   <IconButton
                     size="large"
                     edge="end"
                     aria-label="account of current user"
                     aria-controls={menuId}
                     aria-haspopup="true"
                     color="inherit"
                   >
                     <AccountCircle />
                   </IconButton>
                 </Box>
          
               </Toolbar>
             </AppBar>
           </Box>
      {matchesResolution === false?
      <Box sx={{ flexGrow: 1, position:"fixed", bottom:"-5px", zIndex:"9999", width:"100%" }}>
      <BottomNavigation
        showLabels
        value={bottomMenuValue}
        onChange={(event, newValue) => {
          setBottomMenuValue(newValue);
        }}
      >
         <BottomNavigationAction component={Link} to={'/'} label="Início" icon={<HomeRoundedIcon />} />
        <BottomNavigationAction  label="Buscar" icon={<SearchIcon />} onClick={()=> inputRef.current.focus()}/>
        <BottomNavigationAction label="Perfil" disabled={true} icon={<AccountCircle />} />
      </BottomNavigation>
    </Box>
      :
      <></>
      }
    
    </>
    );
}
export default TopMenu
